import useTranslation from 'hooks/useTranslation'
import { toPhoneString } from 'utils/string'
import React, { useState } from 'react'
import { PopupProps, Sharing } from '.'
import { toDateTime } from 'utils/date'

interface ShareItemProps extends Sharing {
  openPopup: (popup: PopupProps) => void
}

const ShareItem: React.FC<ShareItemProps> = ({ userName, userPhone, permissions, openPopup }) => {
  const [expanded, expand] = useState(false)
  const { t, lang } = useTranslation('account')

  return (
    <div className='list__item'>
      <div
        className='group'
        onClick={() => {
          expand(e => !e)
        }}>
        <div className='item__desc'>
          <div>{userName}</div>
          <div>{toPhoneString(userPhone.toString())}</div>
        </div>
        <i className={`icon icon--chevron-${expanded ? 'up' : 'down'}`} />
      </div>
      <div className={`hidableElement --${expanded ? 'visible' : 'hidden'}`}>
        <div>
          <div className='account__list account__subList'>
            {permissions.map(({ id: permissionId, validUntil, oneTime, isActive, disabled, functions, warehouseId, warehouseNumber, warehouseAddress }) => {
              const type = oneTime ? 'one-time-access' : validUntil ? 'time-access' : 'permanent-access'
              return <div
                key={permissionId}
                className='list__item'
                style={(!isActive || disabled) ? { opacity: 0.5 } : undefined}
                onClick={() => {
                  if (warehouseId) {
                    openPopup({
                      type: 'share',
                      body: {
                        warehouseId,
                        permissionId,
                        action: type
                      }
                    })
                  }
                }}>
                <div className='group'>
                  <div className='center'>
                    <div className='item__icon center'>
                      <i className={`icon icon--${oneTime ? 'oneTimeAccess' : validUntil ? 'clock' : 'infinity'} ${type === 'permanent-access' ? 's24' : 's32'}`} />
                    </div>
                    <div className='item__desc'>
                      <div className='--secFont'>Magazyn nr.{warehouseNumber}</div>
                      <div>{warehouseAddress}</div>
                      <div>
                        <span>{t(type)}</span>
                        {validUntil && <span>: {toDateTime(validUntil, lang)}</span>}
                      </div>
                      {functions && functions.length > 0 && <div>{functions.map((f, i) => `${i ? ', ' : ''}${t(f)}`)}</div>}
                      {disabled && <div>{t('temporaryDeactivationOfAccess')}</div>}
                    </div>
                  </div>
                  <i className='icon icon--arrow-right' />
                </div>
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShareItem